import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconApprovalDelegation.tsx
const OutlinedFilledApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M245-103v-391h94q8 0 16.5 1.5T372-488l218 81q42 16 71 48t29 76q0 1-.5 3t-3.5 2h-81q-34 0-68-5.5T471-299l-78-22-15 42 71 24q39 13 80 17.5t84 4.5h177q50 0 83 40.5t33 91.5L569-9l-324-94ZM19-55v-439h165v439H19Zm541-504L372-748l67-67 121 122 234-233 67 65-301 302Z" })
});
const OutlinedApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302ZM269-195l296 88 248-78q0-20-15.5-33.5T761-232H545q-10 0-24.83-2.5-14.82-2.5-30.17-7.18L394-270l21-61 101 34q7 3 16 4.5t20 .5h56q0-21-14-36.5T560-352l-218-83h-73v240ZM20-55v-463h319q8 0 16.5 1.5T373-512l215 81q44 17 75 53.5t31 85.5h67q60.58 0 102.79 33.5Q906-225 906-167v43L570-21l-301-87v53H20Zm83-82h82v-298h-82v298Z" })
});
const RoundedFilledApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m542-17-297-86v-391h94q9 0 17 1.5t16 4.5l218 81q44 17 72 52.5t28 71.5q0 1-.5 3t-3.5 2h-81q-36 0-68-5t-66-16l-53-15q-11-3-20 0t-13 14q-3 10 2 18t14 11l48 16q27 9 66.5 15.5T613-233h157q74 0 105 31.5T906-101L594-16q-14 3-26 3t-26-4ZM19-120v-308q0-27 19.5-46.5T85-494h34q27 0 46 19.5t19 46.5v308q0 27-19 46t-46 19H85q-27 0-46.5-19T19-120Zm541-573 202-201q14-14 33-13.5t33 13.5q14 14 14 33.5T828-827L594-593q-14 15-34 15t-34-15L405-715q-14-14-14.5-32.5T404-781q14-14 34-14t34 14l88 88Z" })
});
const RoundedApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m560-693 202-201q14-14 33-13.5t33 13.5q14 14 14 33.5T828-827L594-593q-14.73 15-34.36 15Q540-578 526-593L405-715q-14-14-14.5-32.5T404-781q14-14 34-14t34 14l88 88Zm5 586 248-78q0-20-15.5-34T761-232H545q-10 1-24.83-2-14.82-3-30.17-7.94l-66-19.83q-12-2.95-18-15.14-6-12.18-2-24.38 4-11.85 15.5-17.78Q431-325 443-320l73 23q7 3 16.24 4.43 9.23 1.43 19.87.57h55.96-.07q0-21-14-36.5T560-352l-218-83h-73v240l296 88Zm-23 78-273-79q-9 28-37 40.5T175-55h-61q-39.03 0-66.51-27.49Q20-109.97 20-149v-275q0-39.02 27.49-66.51Q74.97-518 114-518h225q8 0 16.5 1.5T373-512l215 81q48 19 77 54.5t29 84.5h67q60.58 0 102.79 33.5Q906-225 906-167q0 18.72-10.5 33.86T870-113L596-29q-13 3-27 3t-27-3ZM103-137h82v-298h-82v298Z" })
});
const SharpFilledApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302ZM19-55v-439h165v439H19Zm549 45-323-92v-392h110l327 121v95H534l-142-45-14 43 136 47h391v132L568-10Z" })
});
const SharpApprovalDelegation = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M560-559 372-748l67-67 121 122 234-233 67 65-301 302Zm8 538-299-87v53H20v-439h336l338 126v90h212v154L568-21ZM102-137h83v-274h-83v274Zm462 30 256-78v-33H518l-126-40 22-58 115 38h77v-32L341-411h-72v216l295 88Z" })
});
const componentMap = {
	outlined: OutlinedApprovalDelegation,
	"outlined-fill": OutlinedFilledApprovalDelegation,
	rounded: RoundedApprovalDelegation,
	"rounded-fill": RoundedFilledApprovalDelegation,
	sharp: SharpApprovalDelegation,
	"sharp-fill": SharpFilledApprovalDelegation
};
const IconApprovalDelegation = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconApprovalDelegation };